// extracted by mini-css-extract-plugin
export default {"show2FAKeyButton":"QRCodeComponent_show2FAKeyButton__-m3mW"};